import { render, staticRenderFns } from "./PcDropdownReskinned.vue?vue&type=template&id=1af1125c"
import script from "./PcDropdownReskinned.vue?vue&type=script&lang=js"
export * from "./PcDropdownReskinned.vue?vue&type=script&lang=js"
import style0 from "./PcDropdownReskinned.vue?vue&type=style&index=0&id=1af1125c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VList,VListItem,VListItemAction,VListItemTitle,VMenu,VRow})
